import { Dictionary } from './dictionary'
import { Figure } from './figure'
import { Note } from './note'
import { Pair } from './pair'
import { Quiz } from './quiz'
import { Word } from './word'

export enum HomeElemType {
  Word = 'word',
  Pair = 'pair',
  Dictionary = 'dictionary',
  Note = 'note',
  Quiz = 'quiz',
  Figure = 'figure',
}

export type HomeElemWord = Word & {
  type: HomeElemType.Word
}

export type HomeElemPair = Pair & {
  type: HomeElemType.Pair
}

export type HomeElemDictionary = Dictionary & {
  type: HomeElemType.Dictionary
}

export type HomeElemNote = Note & {
  type: HomeElemType.Note
}

export type HomeElemQuiz = Quiz & {
  type: HomeElemType.Quiz
}

export type HomeElemFigure = Figure & {
  type: HomeElemType.Figure
}

export type HomeElem =
  HomeElemWord | HomeElemPair | HomeElemDictionary | HomeElemNote | HomeElemQuiz | HomeElemFigure
